mdApp.directive('headerMenu', function(){
	return {
		retrict: 'E',
		scope: true,
		compile: function(){
			return function(scope, element){
				var $menu = jQuery('.menu-header-container');
				var menuActive = false;
				scope.toggle =  function(){
					if (menuActive) {
						$menu.removeClass('active');
						element.removeClass('active');
						jQuery('body').removeClass('menu-opened');
					}else{
						$menu.addClass('active');
						element.addClass('active');
						jQuery('body').addClass('menu-opened');
					}
					menuActive = !menuActive;
				}
			}
		}
	}
})